export enum EduFormField {
  Product = 'product_id',
  Title = 'title',
  Description = 'description',
  Attachments = 'attachments',
  PreferredEmail = 'preferred_email',
  UserImpact = 'user_impact',
  ProductFeatureArea = 'product_feature_area',
  LMS = 'lms',
  NewSdsCustomer = 'new_customer',
}

export const EduQueryParameter = {
  ProductId: 'product_id',
  PlatformId: 'platform_id',
  ClientId: 'client_id',
  ProductFeatureAreaId: 'product_feature_area_id',
  AppVersion: 'app_version',
  ErrorCode: 'error_code',
  Ring: 'ring',
  ResourceId: 'resource_id',
  MeetingId: 'meeting_id',
  LanguageCode: 'lang_code',
  LmsId: 'lms_id',
};

export const EduKeyValueMap = {
  ClientNames: {
    'lt_landing_page': 'Learning Tools Landing Page',
    'onenote_ios': 'OneNote iOS',
    'onenote_mac': 'OneNote Mac',
    'onenote_uwp': 'OneNote UWP',
    'onenote_wac': 'OneNote WAC',
    'onenote_desktop': 'OneNote Desktop',
    'excel_desktop': 'Excel Desktop',
    'owa': 'OWA',
    'word_wac': 'Word WAC',
    'word_viewer': 'Word Viewer',
    'write_ideas': 'WriteIdeas',
    'lti': 'LTI',
    'teams': 'Microsoft Teams',
  },
  PlatformNames: {
    'universal': 'Universal',
    'windows_desktop': 'Windows Desktop',
    'ios': 'iOS',
    'android': 'Android',
    'web': 'Web',
    'mac': 'Mac',
  },
  ProductFeatureAreaNames: {
    'teams_assignments': 'Teams - Assignments',
    'cnb_online_errors': 'Class Notebook - Online Errors',
    'cnb_education_connector': 'Class Notebook - Education Connector',
    'education_resources_content_issue': 'Edu Resources - Content Issue',
    'teams_classes': 'Teams Classes',
    'teams_meetings': 'Teams Meetings',
    'assignments_lti': 'Assignments LTI',
    'onedrive': 'OneDrive',
  },
  LmsNames: {
    'blackboard': 'Blackboard',
    'canvas': 'Canvas',
    'brightspace': 'D2L Brightspace',
    'moodle': 'Moodle',
    'openlms': 'Open LMS',
    'other': 'Other',
    'schoology': 'Schoology',
  },
};

export const EduSdsTermsLinks = {
  OnlineServiceTerms: 'https://www.microsoftvolumelicensing.com/DocumentSearch.aspx?Mode=3&DocumentTypeId=46',
  MicrosoftPrivacyStatement: 'https://privacy.microsoft.com/privacystatement',
  MllCustomerSuccessDisclosure: 'https://docs.microsoft.com/schooldatasync/MLL-Customer-Success-Disclosure',
};

export const EduProductId = {
  ImmersiveReader: "immersive_reader",
  ClassInsights: "class_insights",
  LtiApps: "lti_apps",
  MathAssistant: "math_assistant",
  Forms: "forms",
  Stream: "stream",
  Teams: "teams",
  Whiteboard: "whiteboard",
  MathCoach: "math_coach",
  MieExpertProgram: "mie_expert_program",
  MinecraftEducation: "minecraft_education",
  ClassNotebook: "cnb",
  SuccessSeries: "success_series",
  ReadingProgress: "reading_progress",
  Reflect: "reflect",
  SchoolDataSync: "data_sync",
  SearchCoach: "search_coach",
  Win11SeSupport: "win11se_support",
  SchoolConnection: "school_connection",
  SpeakerProgress: "speaker_progress",
  ReadingCoach: "reading_coach",
  Copilot: "copilot",
  LearningZone: "learning_zone",
  LearningActivities: "learning_activities",
};
